module.exports = __webpack_public_path__ + "static/img/fish24.6bad979.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fish/fugufish/fish24.png
// module id = F851
// module chunks = 0